var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAuth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_49921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.501 50.002C39.3087 50.002 50.502 38.8087 50.502 25.001C50.502 11.1933 39.3087 0 25.501 0C11.6933 0 0.5 11.1933 0.5 25.001C0.5 38.8087 11.6933 50.002 25.501 50.002Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 40.9102C16.7134 40.9102 9.59183 33.7886 9.59183 25.001C9.59183 16.2134 16.7134 9.09183 25.501 9.09183C29.8928 9.09183 33.8696 10.8727 36.7505 13.7516L43.179 7.32302C38.6542 2.79826 32.403 0 25.501 0C11.693 0 0.5 11.193 0.5 25.001C0.5 38.809 11.693 50.002 25.501 50.002C32.405 50.002 38.6542 47.2038 43.181 42.681L36.7525 36.2525C33.8696 39.1293 29.8928 40.9102 25.501 40.9102Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4102 25.0005H33.4546C33.4546 20.6087 29.8928 17.0449 25.499 17.0449C21.1052 17.0449 17.5454 20.6067 17.5454 25.0005C17.5454 27.14 18.3915 29.0801 19.7675 30.5124L19.7615 30.5185L29.6108 40.3678L29.6128 40.3698C36.406 38.5567 41.4102 32.3638 41.4102 25.0005Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 25.001H41.4082C41.4082 32.3643 36.4019 38.5571 29.6128 40.3703L36.6336 47.3911C44.8531 43.2954 50.5 34.808 50.5 25.001Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 49.7164C11.7414 49.7164 0.580583 38.5999 0.502015 24.8584C0.502015 24.9067 0.5 24.9531 0.5 25.0014C0.5 38.8094 11.693 50.0024 25.501 50.0024C39.309 50.0024 50.502 38.8094 50.502 25.0014C50.502 24.9531 50.5 24.9067 50.5 24.8584C50.4214 38.5999 39.2586 49.7164 25.501 49.7164Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6148 40.3703L29.8364 40.5919C36.5127 38.7062 41.4102 32.5698 41.4102 25.285V25.001C41.4102 32.3643 36.404 38.5571 29.6148 40.3703Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9562 22.7275H25.5001C24.245 22.7275 23.2277 23.7449 23.2277 25C23.2277 26.2551 24.245 27.2724 25.5001 27.2724H45.9542C47.2093 27.2724 48.2267 26.2551 48.2267 25C48.2287 23.7449 47.2113 22.7275 45.9562 22.7275Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.9562 22.7275H25.5001C24.245 22.7275 23.2277 23.7449 23.2277 25C23.2277 26.2551 24.245 27.2724 25.5001 27.2724H45.9542C47.2093 27.2724 48.2267 26.2551 48.2267 25C48.2287 23.7449 47.2113 22.7275 45.9562 22.7275Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04492 26.7056C5.9862 26.7056 6.74926 25.9425 6.74926 25.0012C6.74926 24.0599 5.9862 23.2969 5.04492 23.2969C4.10364 23.2969 3.34058 24.0599 3.34058 25.0012C3.34058 25.9425 4.10364 26.7056 5.04492 26.7056Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 6.2495C26.4423 6.2495 27.2054 5.48644 27.2054 4.54516C27.2054 3.60388 26.4423 2.84082 25.501 2.84082C24.5598 2.84082 23.7967 3.60388 23.7967 4.54516C23.7967 5.48644 24.5598 6.2495 25.501 6.2495Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 47.1597C26.4423 47.1597 27.2054 46.3966 27.2054 45.4553C27.2054 44.514 26.4423 43.751 25.501 43.751C24.5598 43.751 23.7967 44.514 23.7967 45.4553C23.7967 46.3966 24.5598 47.1597 25.501 47.1597Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0121 12.2407C11.9534 12.2407 12.7165 11.4777 12.7165 10.5364C12.7165 9.59509 11.9534 8.83203 11.0121 8.83203C10.0709 8.83203 9.3078 9.59509 9.3078 10.5364C9.3078 11.4777 10.0709 12.2407 11.0121 12.2407Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0121 41.1948C11.9534 41.1948 12.7165 40.4318 12.7165 39.4905C12.7165 38.5492 11.9534 37.7861 11.0121 37.7861C10.0709 37.7861 9.3078 38.5492 9.3078 39.4905C9.3078 40.4318 10.0709 41.1948 11.0121 41.1948Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9899 41.1938C40.9312 41.1938 41.6943 40.4308 41.6943 39.4895C41.6943 38.5482 40.9312 37.7852 39.9899 37.7852C39.0486 37.7852 38.2856 38.5482 38.2856 39.4895C38.2856 40.4308 39.0486 41.1938 39.9899 41.1938Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 23.0126H45.9551C47.1619 23.0126 48.149 23.9554 48.2195 25.144C48.2215 25.0957 48.2276 25.0493 48.2276 25.001C48.2276 23.7459 47.2102 22.7285 45.9551 22.7285H25.501C24.2459 22.7285 23.2286 23.7459 23.2286 25.001C23.2286 25.0493 23.2306 25.0957 23.2366 25.144C23.3071 23.9554 24.2923 23.0126 25.501 23.0126Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2195 25.1416C48.145 26.3282 47.1598 27.273 45.9551 27.273H25.501C24.2943 27.273 23.3071 26.3302 23.2366 25.1416C23.2306 25.19 23.2286 25.2363 23.2286 25.2826C23.2286 26.5377 24.2459 27.5551 25.501 27.5551H45.9551C47.2102 27.5551 48.2276 26.5377 48.2276 25.2826C48.2276 25.2363 48.2256 25.19 48.2195 25.1416Z",
    fill: "#212121",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 9.37617C29.8928 9.37617 33.8696 11.1571 36.7504 14.0359L43.318 7.46432C43.2696 7.41597 43.2233 7.36762 43.177 7.32129L36.7504 13.7498C33.8696 10.871 29.8928 9.0901 25.501 9.0901C16.7134 9.0901 9.5918 16.2117 9.5918 24.9993C9.5918 25.0476 9.59381 25.094 9.59381 25.1423C9.67037 16.4212 16.7617 9.37617 25.501 9.37617Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.501 50.002C39.3087 50.002 50.502 38.8087 50.502 25.001C50.502 11.1933 39.3087 0 25.501 0C11.6933 0 0.5 11.1933 0.5 25.001C0.5 38.8087 11.6933 50.002 25.501 50.002Z",
    fill: "url(#paint0_radial_687_49921)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_687_49921",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.8317 7.27477) scale(49.9157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_49921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuth);
export default __webpack_public_path__ + "static/media/google-auth.a8d6facda3f14f883d39159783d4629f.svg";
export { ForwardRef as ReactComponent };